<div class="mdk-app-header">
  <div class="mdk-app-header__content">
    <div class="mdk-app-header__content__column mdk-brand">
      <a [attr.href]="headerLogoUrl" target="_blank">
        <div class="mdk-app-header__content__image-container">
          <div class="mdk-app-header__content__image-container__layout">
            <div
              class="mdk-app-header__content__image-container__layout__logo mdk-app-header__content__image-container__layout__logo--internal"
            >
              <img src="vlaanderen-logo.svg" alt="vlaanderen logo" />
            </div>
          </div>
        </div>
        <div class="mdk-app-header__content__logo-title">Vlaanderen</div>
      </a>

      <a href="/">
        <div class="mdk-app-header__content__header-title">{{ title }}</div>
      </a>
    </div>
    <div class="mdk-app-header__content__column"></div>
    <div class="mdk-app-header__content__column">
      <div class="mdk-app-header__content__login">
        <mdk-user-menu *ngIf="isUserAuthenticated"></mdk-user-menu>
        <mdk-login-button
          *ngIf="!isUserAuthenticated && !isAuthSessionLoading"
        ></mdk-login-button>
        <!-- Shows loader when loading in AUTH session takes to long -->
        <button
          *ngIf="isAuthSessionLoading"
          class="vl-button vl-button--icon-before vl-button--disabled vl-button--loading mdk-login-button"
          style="line-height: normal; margin-top: 0; margin-bottom: 0"
        >
          <i
            class="vl-button__icon vl-button__icon--login vl-button__icon--before vl-vi vl-vi-burgerprofiel"
            aria-hidden="true"
          ></i>
          <span class="vl-button__label">AANMELDEN</span>
        </button>
      </div>
    </div>
    <div class="mdk-app-header__content__column">
      <div class="mdk-app-header__content__contact">
        <mdk-contact-button></mdk-contact-button>
      </div>
    </div>
  </div>
</div>
